import { Alert, Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { useVisningsOgDelingFormContext } from '../../utils';

import { SamtykkeRadioWrapper } from './styledComponents';

export const SamtykkeRadio = ({ disabled }: { disabled?: boolean }) => {
  const { t } = useTranslation('', { keyPrefix: 'form.samtykke.deling' });
  const { register, watch, formState } = useVisningsOgDelingFormContext();

  const error = formState.errors.synlighet?.message;
  const synlighetStatus = watch('synlighet');

  return (
    <SamtykkeRadioWrapper>
      <Fieldset disabled={disabled}>
        <Fieldset.Legend data-size={'lg'}>{t('radio.title')}</Fieldset.Legend>
        <Radio
          {...register('synlighet', {
            required: t('radio.error')
          })}
          label={t('radio.grant')}
          value={'offentlig'}
          aria-invalid={!!error}
        />
        <Radio
          {...register('synlighet', {
            required: t('radio.error')
          })}
          label={t('radio.revoke')}
          value={'reservert'}
          aria-invalid={!!error}
        />
        {synlighetStatus == 'reservert' && <Alert>{t('radio.revoke_warning')}</Alert>}
        {error && <ValidationMessage data-color="danger">{t('radio.error')}</ValidationMessage>}
      </Fieldset>
    </SamtykkeRadioWrapper>
  );
};
